'use client';

import React from 'react';
import { useCalendly } from '@/components/CalendlyPopup';

export default function BookConsultationButton({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  const { open } = useCalendly();

  return (
    <button type="button" onClick={open} className={className}>
      {children}
    </button>
  );
}
